import { 
    CREATE_PROJECTASSUMPTIONS_REQUEST,
    CREATE_PROJECTASSUMPTIONS_SUCCESS,
    CREATE_PROJECTASSUMPTIONS_FAILURE
 } from "./ProjectAssumptionsTypes";

const initialState = {
  loading: true,
  data: [],
  errorMsg: "",
};

const projectAssumptionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_PROJECTASSUMPTIONS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CREATE_PROJECTASSUMPTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        errorMsg: "",
      };
    case CREATE_PROJECTASSUMPTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        data: [],
        errorMsg: action.payload,
      };
    default:
      return state;
  }
};

export default projectAssumptionsReducer;
